import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Table, Image, Popup } from 'semantic-ui-react';
import DateCell from './shared/DateCell';
import Money from './shared/Money';
import DappTokenTransfers from './containers/DappTokenTransfers';
import eye from '../assets/images/eye@2x.png';

import DappPopup from './DappPopup';

const color = (direction) => (direction.toLowerCase() === 'credit' ? 'green' : 'red');

const DappTokenTransferRow = ({ tokenTransfer, showDetails }) => {
    return (
        <Table.Row>
            {/* <Table.Cell collapsing>
				<span className={`text-${color(transfer.transactionDirection)} bold`}>
					{transfer.transactionDirection.toUpperCase()}
				</span>
			</Table.Cell> */}
            <Table.Cell collapsing>
                <DateCell date={tokenTransfer.consensusTime} />
            </Table.Cell>
            <Table.Cell collapsing>
                {tokenTransfer.from}
            </Table.Cell>
            {/* <Table.Cell width="4" textAlign="left" collapsing>

                <div
                    style={{
                        width: '100%',
                        maxWidth: '100%',
                        wordWrap: 'break-word',
                        wordBreak: 'break-word'
                    }}
                >
                    {`${tokenTransfer.functionParameters.slice(0, 20)}...`} &nbsp;
                    <DappPopup parameters={tokenTransfer.decodedFunctionParams} />
                </div>
            </Table.Cell> */}
            <Table.Cell collapsing>
                {tokenTransfer.to}
            </Table.Cell>
            <Table.Cell collapsing>
                {tokenTransfer.symbol} {tokenTransfer.amount}
            </Table.Cell>
            <Table.Cell textAlign="center" collapsing>
                <Link to={`/transactions/${tokenTransfer.transactionID}`}>
                    <Popup
                        content="View Transaction Details"
                        trigger={<Image src={eye} rounded size="mini" style={{ width: '28px' }} />}
                    />
                </Link>
            </Table.Cell>
        </Table.Row>
    );
};

export default DappTokenTransferRow;

DappTokenTransferRow.propTypes = {
    tokenTransfer: PropTypes.object.isRequired
};
